namespace Matrix.Administration {
    export interface GroupRoleRow {
        GroupId?: string;
        RoleName?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        GroupName?: string;
    }

    export namespace GroupRoleRow {
        export const idProperty = 'RowId';
        export const localTextPrefix = 'Administration.GroupRole';
        export const deletePermission = 'Administration:Security';
        export const insertPermission = 'Administration:Security';
        export const readPermission = 'Administration:Security';
        export const updatePermission = 'Administration:Security';

        export declare const enum Fields {
            GroupId = "GroupId",
            RoleName = "RoleName",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            GroupName = "GroupName"
        }
    }
}
